var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1436,
    height: 674,
    viewBox: "0 0 1439 674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-46.6819 -185.104L-113.974 -215.478V27.5171H-46.6819H289.777H693.527H1097.28H1433.74H1501.03V-458.473L1433.74 -418.037C1366.44 -376.842 1231.86 -297.109 1097.28 -286.288C1038.43 -281.889 979.576 -291.029 920.725 -300.169C844.993 -311.931 769.26 -323.693 693.527 -306.601C626.235 -291.414 558.944 -253.446 491.652 -215.478C424.36 -177.51 357.068 -139.542 289.777 -124.355C155.193 -93.9805 20.6098 -154.729 -46.6819 -185.104ZM-46.6819 240.138L-113.974 270.513V27.5175H-46.6819H289.777H693.527H1097.28H1433.74H1501.03V513.508L1433.74 473.072C1366.44 431.877 1231.86 352.144 1097.28 341.323C1038.43 336.923 979.576 346.063 920.725 355.204C844.993 366.966 769.26 378.728 693.527 361.636C626.235 346.449 558.944 308.481 491.652 270.513C424.36 232.545 357.068 194.577 289.777 179.389C155.193 149.015 20.6098 209.764 -46.6819 240.138Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-345.791 -320.531L-442 -373.25V48.4996H-345.791H135.257H712.514H1289.77H1770.82H1867.03V-795L1770.82 -724.818C1674.61 -653.318 1482.19 -514.932 1289.77 -496.151C1205.63 -488.514 1121.49 -504.379 1037.35 -520.243C929.07 -540.657 820.792 -561.072 712.514 -531.406C616.304 -505.047 520.095 -439.149 423.885 -373.25C327.676 -307.352 231.466 -241.453 135.257 -215.094C-57.162 -162.375 -249.581 -267.813 -345.791 -320.531ZM-345.791 417.531L-442 470.25V48.5004H-345.791H135.257H712.514H1289.77H1770.82H1867.03V892L1770.82 821.818C1674.61 750.318 1482.19 611.932 1289.77 593.151C1205.63 585.515 1121.49 601.379 1037.35 617.243C929.07 637.657 820.792 658.072 712.514 628.406C616.304 602.047 520.095 536.149 423.885 470.25C327.676 404.352 231.466 338.453 135.257 312.094C-57.162 259.375 -249.581 364.813 -345.791 417.531Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-254.172 -345.584L-333 -372.233V-159.041H-254.172H139.967H612.934H1085.9H1480.04H1558.87V-585.425L1480.04 -549.949C1401.21 -513.806 1243.56 -443.853 1085.9 -434.359C1016.96 -430.499 948.022 -438.518 879.082 -446.537C790.366 -456.857 701.65 -467.176 612.934 -452.18C534.106 -438.856 455.278 -405.545 376.451 -372.233C297.623 -338.922 218.795 -305.611 139.967 -292.286C-17.6886 -265.637 -175.344 -318.935 -254.172 -345.584ZM-333 54.1508V-159.041H-254.172H139.967H612.934H1085.9H1480.04H1558.87V267.343L1480.04 231.866C1401.21 195.724 1243.56 125.77 1085.9 116.276C1016.96 112.416 948.022 120.435 879.082 128.455C790.366 138.774 701.65 149.094 612.934 134.098C534.106 120.773 455.278 87.4621 376.451 54.1509C297.623 20.8396 218.795 -12.4717 139.967 -25.7962C-17.6886 -52.4452 -175.344 0.852783 -254.172 27.5018L-333 54.1508Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1501.03,
    y1: -458.473,
    x2: -13.0276,
    y2: -175.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A66C2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25abd1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1867.03,
    y1: -795,
    x2: -321.454,
    y2: -457.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A66C2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A66C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 3118.5,
    y1: -421.567,
    x2: -155.709,
    y2: -205.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A66C2",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A66C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1439,
    height: 674,
    fill: "#0A66C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.d981d110d9c10c4bad4bcb795fd3bb9d.svg";
export { ForwardRef as ReactComponent };